import React, { useState, useEffect } from 'react';
import './Promociones.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function Promociones() {
  const [promociones, setPromociones] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPromociones();
  }, []);

  const fetchPromociones = async () => {
    try {
      const res = await fetch(`${API_URL}/api/promociones?active_only=true`);
      const data = await res.json();
      setPromociones(data.promociones || []);
    } catch (error) {
      console.error('Error fetching promociones:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-MX', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  if (loading) {
    return (
      <section id="promociones" className="promociones-section" data-testid="promociones-section">
        <div className="promociones-container">
          <div className="promociones-header">
            <span className="promociones-badge">NOVEDADES</span>
            <h2 className="promociones-title">Promociones</h2>
          </div>
          <div className="promociones-loading">
            <div className="loading-spinner"></div>
            <p>Cargando promociones...</p>
          </div>
        </div>
      </section>
    );
  }

  if (promociones.length === 0) {
    return null;
  }

  return (
    <section id="promociones" className="promociones-section" data-testid="promociones-section">
      <div className="promociones-container">
        <div className="promociones-header">
          <span className="promociones-badge">NOVEDADES</span>
          <h2 className="promociones-title">Promociones</h2>
          <p className="promociones-subtitle">
            Entérate de nuestras últimas promociones, platillos de temporada y eventos especiales
          </p>
        </div>

        <div className="promociones-list">
          {promociones.map((promo) => (
            <article 
              key={promo.id} 
              className="promo-card"
              data-testid={`promo-card-${promo.id}`}
            >
              <div className="promo-image-wrapper">
                <img 
                  src={promo.image_url} 
                  alt={promo.title}
                  className="promo-image"
                  loading="lazy"
                />
              </div>
              <div className="promo-content">
                <time className="promo-date">{formatDate(promo.created_at)}</time>
                <h3 className="promo-title">{promo.title}</h3>
                <div className="promo-text">
                  {promo.content.split('\n').map((paragraph, idx) => (
                    paragraph.trim() && <p key={idx}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
